import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Layers = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M19.5742 3.09518C19.8439 2.96827 20.1561 2.96827 20.4258 3.09518L37.4258 11.0952C37.7763 11.2601 38 11.6126 38 12C38 12.3874 37.7763 12.7399 37.4258 12.9048L20.4258 20.9048C20.1561 21.0317 19.8439 21.0317 19.5742 20.9048L2.5742 12.9048C2.22371 12.7399 2 12.3874 2 12C2 11.6126 2.22371 11.2601 2.5742 11.0952L19.5742 3.09518ZM5.34854 12L20 18.8948L34.6515 12L20 5.10519L5.34854 12ZM2.11621 18.5321C2.37462 18.044 2.97979 17.8578 3.46789 18.1162L20 26.8685L36.5321 18.1162C37.0202 17.8578 37.6254 18.044 37.8838 18.5321C38.1422 19.0202 37.956 19.6254 37.4679 19.8838L20.4679 28.8838C20.1752 29.0387 19.8248 29.0387 19.5321 28.8838L2.53211 19.8838C2.04401 19.6254 1.85781 19.0202 2.11621 18.5321ZM2.11621 26.5321C2.37462 26.044 2.97979 25.8578 3.46789 26.1162L20 34.8685L36.5321 26.1162C37.0202 25.8578 37.6254 26.044 37.8838 26.5321C38.1422 27.0202 37.956 27.6254 37.4679 27.8838L20.4679 36.8838C20.1752 37.0387 19.8248 37.0387 19.5321 36.8838L2.53211 27.8838C2.04401 27.6254 1.85781 27.0202 2.11621 26.5321Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Layers;
